import { Helmet } from 'react-helmet'

import Brand from 'helpers/brand'
import Environment from 'helpers/environment'
import GA4 from 'helpers/ga4'
import Apptentive from 'helpers/apptentive'

import { datadogRum } from '@datadog/browser-rum'

const Head = () => {
  const googleAnalyticsId = GA4.googleAnalyticsId()

  return (
    <Helmet>
      <title>{Brand.productName()}</title>

      <link rel="shortcut icon" href={Brand.faviconPath()} />

      <meta charset="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
      />
      <meta
        httpEquiv="X-UA-Compatible"
        content="IE=edge,chrome=1"
      />
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap" rel="stylesheet" />

      {Brand.isResidential() && (
        <script async src={'//www.googletagmanager.com/gtag/js?id=' + googleAnalyticsId} />
      )}

      {Brand.isResidential() && (
        <script>{`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
        `}
        </script>
      )}

      {Brand.isResidential() && (
        <script>{'(function initApptentiveSDK(){var ApptentiveSDK=window.ApptentiveSDK=window.ApptentiveSDK||[];if(!ApptentiveSDK.version){if(!ApptentiveSDK.loaded){ApptentiveSDK.loaded=true;ApptentiveSDK.methods=["buildDevice","createConversation","createMessage","engage","getSegments","identifyPerson","setOption","setPageName","showInteraction","showMessageCenter","updatePerson"];ApptentiveSDK.factory=function factory(t){return function f(){for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key]}var e=Array.prototype.slice.call(args);e.unshift(t);ApptentiveSDK.push(e);return ApptentiveSDK}};for(var i=0;i<ApptentiveSDK.methods.length;i++){var method=ApptentiveSDK.methods[i];ApptentiveSDK[method]=ApptentiveSDK.factory(method)}ApptentiveSDK.LOADER_VERSION="1.0.0"}}})();'}</script>
      )}

      {Brand.isResidential() && (<script async src={`https://sdk.apptentive.com/v1/apps/${Apptentive.getApptentiveAccountId()}/websdk`} />)}

      {Environment.isProduction() && (
        <script src="//rum-static.pingdom.net/pa-58121709293aecd24d0285b8.js" async />
      )}

      {(Environment.isProduction() || Environment.isQA()) && (
        datadogRum.init({
          applicationId: '1437acfa-3fa3-4c4d-a652-bfa2d9ef3b43',
          clientToken: 'pub77b0ea5e7608fedc298a3c31ed3bdd44',
          site: 'datadoghq.com',
          service: 'diagnostics-webapp',
          allowedTracingUrls: [/https:\/\/.*\.tranehome\.com/, /https:\/\/.*\.asairhome\.com/, /https:\/\/.*\.trane\.com/],
          env: Environment.name(),
          sessionSampleRate: 100,
          sessionReplaySampleRate: 20,
          trackUserInteractions: true,
          trackResources: true,
          trackLongTasks: true,
          defaultPrivacyLevel: 'mask-user-input'
        })
      )}

      {(Environment.isProduction() || Environment.isQA()) && (
        datadogRum.startSessionReplayRecording()
      )}
    </Helmet>
  )
}

export default Head
